module.exports = __webpack_public_path__ + "img/postAdImage.d316d583.png";